<template>
  <icon-base
    v-if="expanded"
    height="21"
    width="21"
    :icon="IconShrinkWhite"
    icon-color="none"
    :icon-name="iconName"
    :class="{ border: hasBorder }"
  />
  <icon-base
    v-else
    height="21"
    width="21"
    :icon="IconExpandWhite"
    icon-color="none"
    :icon-name="iconName"
    :class="{ border: hasBorder }"
  />
</template>
<script type="text/javascript">
import IconExpandWhite from "@/components/icons/IconExpandWhite.vue";
import IconShrinkWhite from "@/components/icons/IconShrinkWhite.vue";

export default {
  name: "ExpandButton",
  props: {
    expanded: {
      type: Boolean,
      default: false,
    },
    hasBorder: {
      type: Boolean,
      default: true,
    },
    iconName: {
      type: String,
      default: "",
    },
  },
  setup() {
    return { IconExpandWhite, IconShrinkWhite };
  },
};
</script>
